import { useTheme } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  Add,
  ArrowDownward,
  AutoAwesome,
  Delete as DeleteIcon,
  KeyboardVoice,
  RestartAlt,
  Send,
} from "@material-ui/icons";
import {
  Avatar,
  Button,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { lazy, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import ModalCVSelection from "./ModalCVSelection";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { Socket, io } from "socket.io-client";
import useSound from "use-sound";
import { User } from "../../users/types/user";
import { Pessoal } from "../hooks/@types/candidateTypes";

//@ts-ignore
import successNot from "../assets/pop.mp3";
//@ts-ignore
import typing from "../assets/loop.mp3";
import { useNotifications } from "../../core/contexts/NotificationsProvider";

const CalendarApp = lazy(() => import("../../calendar/pages/CalendarApp"));

const useStyles = makeStyles({
  visible: {
    "&:hover": {
      color: "#27b279",
    },
  },
});

type UserDialogProps = {
  onAdd?: (user: Partial<User>) => void;
  onClose: () => void;
  onUpdate?: (user: User) => void;
  open: boolean;
  title: string;
  processing: boolean;
  canInfo?: Pessoal;
};

const ModalAgnesAI: React.FC<UserDialogProps> = ({
  onAdd,
  onClose,
  onUpdate,
  open,
  title,
  processing,
  canInfo,
}) => {
  const [play] = useSound(successNot, { volume: 0.05 });
  const [typingSound, { stop }] = useSound(typing, { volume: 0.05 });

  const { socket } = useNotifications();
  const location = useLocation();
  const path = (location.pathname || "").toLowerCase();

  const isDashboard = path.includes("dashboard");
  const isCandidate = path.includes("candidate");
  const isVacancy = path.includes("vacancy");
  const isClients = path.includes("clients");

  const theme = useTheme();
  const d = new Date();
  const [scroll, setScroll] = useState("paper");
  const [height, setHeight] = useState(window.innerHeight);
  const [text, setText] = useState("");
  const [chat, setChat] = useState(
    JSON.parse(localStorage.getItem("chat") || "[]"),
  );
  const [loading, setLoading] = useState(false);
  const [agentStatusMessage, setAgentStatusMessage] = useState<string | null>(
    null,
  );
  const [isWrite, setIsWrite222] = useState(false);

  const setIsWrite = (value: boolean) => {
    console.log("Setting isWrite to:", value);
    setIsWrite222(value);
  };
  const [animationLoading, setAnimationLoading] = useState(true);
  const [showScrollToButton, setShowScrollToButton] = useState(false);
  const [sessions, setSessions] = useState<
    { id: number; title: string; created_at: string; updated_at: string }[]
  >([]);
  const [currentSessionId, setCurrentSessionId] = useState<number | null>(null);
  const [loadingSessions, setLoadingSessions] = useState(false);
  const [loadingMoreSessions, setLoadingMoreSessions] = useState(false);
  const [sessionsPage, setSessionsPage] = useState(1);
  const [hasMoreSessions, setHasMoreSessions] = useState(true);
  const sessionsListRef = useRef<HTMLDivElement>(null);
  const sessionsSentinelRef = useRef<HTMLDivElement>(null);
  const currentSessionIdRef = useRef<number | null>(null);
  const pendingTitleForSessionIdRef = useRef<number | null>(null);
  const [messagesPage, setMessagesPage] = useState(1);
  const [hasMoreMessages, setHasMoreMessages] = useState(false);
  const [loadingMoreMessages, setLoadingMoreMessages] = useState(false);
  const messagesSentinelRef = useRef<HTMLDivElement>(null);
  const pendingScrollRestoreRef = useRef<{ scrollHeight: number; scrollTop: number } | null>(null);
  const [sessionToDelete, setSessionToDelete] = useState<number | null>(null);
  const [deletingSession, setDeletingSession] = useState(false);
  const [selectionCandidatesList, setSelectionCandidatesList] = useState<
    {
      id: number;
      pessoal_nome?: string;
      autohis_codigo?: number;
      [key: string]: any;
    }[]
  >([]);
  const [lastSelectionCandidates, setLastSelectionCandidates] = useState<
    { id: number; pessoal_nome?: string; [key: string]: any }[] | null
  >(null);
  const [modalCVOpen, setModalCVOpen] = useState(false);
  const [modalCVIndex, setModalCVIndex] = useState(0);
  const [modalCVid, setModalCVid] = useState(0);
  const [modalCVAutoHCode, setModalCVAutoHCode] = useState(0);
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition();

  const messagesEndRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLDivElement>(null);
  const dataRef = useRef(chat);

  const apiBase = process.env.REACT_APP_API_URL || "";
  const getAuthHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem("rh-token")}`,
    "Content-Type": "application/json",
  });

  const SESSIONS_PAGE_SIZE = 20;

  const fetchSessions = async () => {
    setLoadingSessions(true);
    setSessionsPage(1);
    setHasMoreSessions(true);
    try {
      const res = await fetch(
        `${apiBase}api/agnes-ai/sessions?page=1&limit=${SESSIONS_PAGE_SIZE}`,
        { headers: getAuthHeaders() },
      );
      if (res.ok) {
        const data = await res.json();
        const list = data?.sessions ?? (Array.isArray(data) ? data : []);
        setSessions(list);
        setHasMoreSessions(data?.hasMore ?? false);
      } else {
        setSessions([]);
      }
    } catch (_) {
      setSessions([]);
    } finally {
      setLoadingSessions(false);
    }
  };

  const loadMoreSessions = async () => {
    if (loadingMoreSessions || !hasMoreSessions) return;
    setLoadingMoreSessions(true);
    const nextPage = sessionsPage + 1;
    try {
      const res = await fetch(
        `${apiBase}api/agnes-ai/sessions?page=${nextPage}&limit=${SESSIONS_PAGE_SIZE}`,
        { headers: getAuthHeaders() },
      );
      if (res.ok) {
        const data = await res.json();
        const list = data?.sessions ?? (Array.isArray(data) ? data : []);
        setSessions((prev) => [...prev, ...list]);
        setHasMoreSessions(data?.hasMore ?? false);
        setSessionsPage(nextPage);
      }
    } catch (_) {}
    setLoadingMoreSessions(false);
  };

  const createNewSession = async () => {
    try {
      const res = await fetch(`${apiBase}api/agnes-ai/sessions`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({ title: "Nova conversa" }),
      });
      if (!res.ok) return;
      const data = await res.json();
      setCurrentSessionId(data.id);
      currentSessionIdRef.current = data.id;
      setSessions((prev) => [
        {
          id: data.id,
          title: data.title || "Nova conversa",
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
        },
        ...prev,
      ]);
      setChat([]);
    } catch (_) {}
  };

  const MESSAGES_PAGE_SIZE = 30;

  const mapMessagesToChat = (
    messages: { id: number; role: string; content: string; created_at: string }[],
  ) =>
    messages.map((m, i) => ({
      id: m.id ?? i + 1,
      text: m.content,
      user: m.role as "user" | "assistant",
      time: m.created_at
        ? new Date(m.created_at).toLocaleTimeString("pt-BR", {
            hour: "2-digit",
            minute: "2-digit",
          })
        : "",
    }));

  const loadSessionMessages = async (sessionId: number) => {
    setCurrentSessionId(sessionId);
    currentSessionIdRef.current = sessionId;
    setMessagesPage(1);
    setHasMoreMessages(false);
    try {
      const res = await fetch(
        `${apiBase}api/agnes-ai/sessions/${sessionId}/messages?page=1&limit=${MESSAGES_PAGE_SIZE}`,
        { headers: getAuthHeaders() },
      );
      if (!res.ok) {
        setChat([]);
        return;
      }
      const data = await res.json();
      const list = data?.messages ?? (Array.isArray(data) ? data : []);
      const mapped = mapMessagesToChat(list);
      setChat(mapped);
      dataRef.current = mapped;
      setHasMoreMessages(data?.hasMore ?? false);
      setTimeout(() => scrollToBottom(), 50);
    } catch (_) {
      setChat([]);
    }
  };

  const loadMoreMessages = async () => {
    const sid = currentSessionIdRef.current;
    if (sid == null || loadingMoreMessages || !hasMoreMessages) return;
    const el = buttonRef.current;
    if (el) {
      pendingScrollRestoreRef.current = {
        scrollHeight: el.scrollHeight,
        scrollTop: el.scrollTop,
      };
    }
    setLoadingMoreMessages(true);
    const nextPage = messagesPage + 1;
    try {
      const res = await fetch(
        `${apiBase}api/agnes-ai/sessions/${sid}/messages?page=${nextPage}&limit=${MESSAGES_PAGE_SIZE}`,
        { headers: getAuthHeaders() },
      );
      if (!res.ok) {
        setLoadingMoreMessages(false);
        return;
      }
      const data = await res.json();
      const list = data?.messages ?? (Array.isArray(data) ? data : []);
      const older = mapMessagesToChat(list);
      setChat((prev: any[]) => [...older, ...prev]);
      dataRef.current = [...older, ...dataRef.current];
      setHasMoreMessages(data?.hasMore ?? false);
      setMessagesPage(nextPage);
    } catch (_) {}
    setLoadingMoreMessages(false);
  };

  const confirmDeleteSession = (e: React.MouseEvent, sessionId: number) => {
    e.stopPropagation();
    setSessionToDelete(sessionId);
  };

  const handleDeleteSession = async () => {
    if (sessionToDelete == null) return;
    setDeletingSession(true);
    try {
      const res = await fetch(
        `${apiBase}api/agnes-ai/sessions/${sessionToDelete}`,
        { method: "DELETE", headers: getAuthHeaders() },
      );
      if (res.ok) {
        setSessions((prev) => prev.filter((s) => s.id !== sessionToDelete));
        if (currentSessionId === sessionToDelete) {
          setCurrentSessionId(null);
          currentSessionIdRef.current = null;
          setChat([]);
          dataRef.current = [];
        }
      }
    } catch (_) {}
    setSessionToDelete(null);
    setDeletingSession(false);
  };

  const saveMessageToSession = async (
    sessionId: number,
    role: "user" | "assistant",
    content: string,
  ) => {
    try {
      await fetch(`${apiBase}api/agnes-ai/sessions/${sessionId}/messages`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify({ role, content }),
      });
    } catch (_) {}
  };

  const generateSessionTitleFromFirstMessage = async (
    sessionId: number,
    firstMessage: string,
  ) => {
    try {
      const res = await fetch(
        `${apiBase}api/agnes-ai/sessions/${sessionId}/generate-title`,
        {
          method: "POST",
          headers: getAuthHeaders(),
          body: JSON.stringify({ firstMessage }),
        },
      );
      if (res.ok) {
        const data = await res.json();
        const title = data?.title || "Nova conversa";
        setSessions((prev) =>
          prev.map((s) =>
            s.id === sessionId
              ? { ...s, title, updated_at: new Date().toISOString() }
              : s,
          ),
        );
      }
    } catch (_) {}
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const isNearBottom = (thresholdPx = 20) => {
    const el = buttonRef.current;
    if (!el) return false;
    const { scrollTop, scrollHeight, clientHeight } = el;
    const distanceFromBottom = scrollHeight - scrollTop - clientHeight;
    return distanceFromBottom <= thresholdPx;
  };

  const handleChatBoxScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } = buttonRef.current!;
    if (scrollHeight * 0.9 < scrollTop + clientHeight) {
      setShowScrollToButton(false);
    } else {
      setShowScrollToButton(true);
    }
  };

  const saveMessageToSessionRef = useRef(saveMessageToSession);
  saveMessageToSessionRef.current = saveMessageToSession;

  useEffect(() => {
    socket?.on("newMessage", async (data: any) => {
      setLoading(false);

      // Verificar se existe uma mensagem no array e se é válida
      if (
        dataRef.current.length === 0 ||
        !dataRef.current[dataRef.current.length - 1]
      ) {
        console.warn("No message to update in chat array");
        return;
      }

      const lastMessage = dataRef.current[dataRef.current.length - 1];

      // Verificar se a mensagem tem a estrutura esperada
      if (!lastMessage || typeof lastMessage !== "object") {
        console.warn("Invalid last message structure");
        return;
      }

      // Atualizar a última mensagem
      const updatedMessage = {
        ...lastMessage,
        user: "assistant",
        text: data.content
          ? (lastMessage.text || "") + data.content
          : lastMessage.text || "",
      };

      dataRef.current[dataRef.current.length - 1] = updatedMessage;
      setChat([...dataRef.current]);

      // Manter o estado de escrita se há conteúdo sendo adicionado
      if (data.content) {
        setIsWrite(true);
      }
    });

    socket?.on("agentStatus", (data: { message?: string | null }) => {
      setAgentStatusMessage(data?.message ?? null);
    });

    socket?.on("streamEnd", () => {
      const sid = currentSessionIdRef.current;
      if (sid && dataRef.current.length > 0) {
        const last = dataRef.current[dataRef.current.length - 1];
        if (last?.user === "assistant" && last?.text) {
          saveMessageToSessionRef.current(sid, "assistant", last.text);
        }
        const pendingTitleId = pendingTitleForSessionIdRef.current;
        if (pendingTitleId && dataRef.current.length >= 1) {
          const firstMsg = dataRef.current[0];
          if (firstMsg?.user === "user" && firstMsg?.text) {
            pendingTitleForSessionIdRef.current = null;
            generateSessionTitleFromFirstMessage(pendingTitleId, firstMsg.text);
          }
        }
      }
      setLoading(false);
      setIsWrite(false);
      setAgentStatusMessage(null);
    });

    socket?.on("agnesSelectionCandidates", (data: { candidates?: any[] }) => {
      if (Array.isArray(data?.candidates) && data.candidates.length > 0) {
        setLastSelectionCandidates(data.candidates);
      }
    });

    // Adicionar listener para erros do servidor
    socket?.on("error", (error: any) => {
      setLoading(false);
      setIsWrite(false);
      setAgentStatusMessage(null);

      // Adicionar mensagem de erro ao chat
      if (error.type === "rate_limit") {
        setChat((prevChat: any) => [
          ...prevChat,
          {
            id: prevChat.length + 1,
            text: `⚠️ **Aviso**: ${error.message}`,
            user: "assistant",
            time: new Date().toLocaleTimeString().slice(0, 5),
          },
        ]);
      } else {
        setChat((prevChat: any) => [
          ...prevChat,
          {
            id: prevChat.length + 1,
            text: `❌ **Erro**: ${
              error.message || "Erro de comunicação com o servidor"
            }`,
            user: "assistant",
            time: new Date().toLocaleTimeString().slice(0, 5),
          },
        ]);
      }
    });

    setAnimationLoading(false);
    const handleResize = () => {
      setHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      socket?.off("newMessage");
      socket?.off("agentStatus");
      socket?.off("streamEnd");
      socket?.off("agnesSelectionCandidates");
      socket?.off("error");
    };
  }, [socket]);

  useEffect(() => {
    scrollToBottom();
  }, [animationLoading]);

  useEffect(() => {
    setText(transcript);
  }, [transcript]);

  useEffect(() => {
    currentSessionIdRef.current = currentSessionId;
  }, [currentSessionId]);

  useEffect(() => {
    if (pendingScrollRestoreRef.current && buttonRef.current) {
      const prev = pendingScrollRestoreRef.current;
      pendingScrollRestoreRef.current = null;
      requestAnimationFrame(() => {
        const el = buttonRef.current;
        if (el) {
          const newHeight = el.scrollHeight;
          el.scrollTop = prev.scrollTop + (newHeight - prev.scrollHeight);
        }
      });
    } else if (isNearBottom(20)) {
      scrollToBottom();
    }
    if (currentSessionId == null) {
      localStorage.setItem("chat", JSON.stringify(chat));
    }
    dataRef.current = [...chat];
  }, [chat, currentSessionId]);

  useEffect(() => {
    if (open) {
      fetchSessions();
    }
  }, [open]);

  useEffect(() => {
    if (!open || !hasMoreSessions || loadingMoreSessions) return;
    const sentinel = sessionsSentinelRef.current;
    if (!sentinel) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) loadMoreSessions();
      },
      { root: sessionsListRef.current, rootMargin: "100px", threshold: 0 },
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [open, hasMoreSessions, loadingMoreSessions, sessions.length]);

  useEffect(() => {
    if (!currentSessionId || !hasMoreMessages || loadingMoreMessages) return;
    const sentinel = messagesSentinelRef.current;
    const root = buttonRef.current;
    if (!sentinel || !root) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) loadMoreMessages();
      },
      { root, rootMargin: "80px", threshold: 0 },
    );
    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [currentSessionId, hasMoreMessages, loadingMoreMessages, chat.length]);

  useEffect(() => {
    if (open) {
      setChat([]);
      setIsWrite(false);
    }
  }, [open]);

  const sendMessageWithText = async (messageToSend: string) => {
    if (!messageToSend || messageToSend.trim().length < 5 || isWrite) return;
    setLastSelectionCandidates(null);
    play();
    resetTranscript();
    const isFirstMessage = chat.length === 0;
    let sessionIdToUse = currentSessionId;
    if (!sessionIdToUse) {
      try {
        const res = await fetch(`${apiBase}api/agnes-ai/sessions`, {
          method: "POST",
          headers: getAuthHeaders(),
          body: JSON.stringify({ title: "Nova conversa" }),
        });
        if (!res.ok) return;
        const data = await res.json();
        sessionIdToUse = data.id;
        setCurrentSessionId(data.id);
        currentSessionIdRef.current = data.id;
        setSessions((prev) => [
          {
            id: data.id,
            title: data.title || "Nova conversa",
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
          },
          ...prev,
        ]);
      } catch (_) {
        return;
      }
    }
    const userMsg = {
      id: chat.length + 1,
      text: messageToSend,
      user: "user" as const,
      time: d.toLocaleTimeString().slice(0, 5),
    };
    const newChat = [
      ...chat,
      userMsg,
      {
        id: chat.length + 2,
        text: "",
        user: "assistant" as const,
        time: d.toLocaleTimeString().slice(0, 5),
      },
    ];
    setChat(newChat);
    if (sessionIdToUse) {
      saveMessageToSession(sessionIdToUse, "user", messageToSend);
      if (isFirstMessage) {
        pendingTitleForSessionIdRef.current = sessionIdToUse;
      }
    }
    const contextCandidateId = canInfo?.pessoal_codigo ?? canInfo?.id;
    const contextCandidateName = canInfo?.pessoal_nome;
    socket?.emit("newMessage", {
      chat: chat,
      text: messageToSend,
      date: d.toLocaleDateString() + " " + d.toLocaleTimeString(),
      ...(contextCandidateId != null && {
        contextCandidateId: Number(contextCandidateId),
      }),
      ...(contextCandidateName && {
        contextCandidateName: String(contextCandidateName),
      }),
    });
    setLoading(true);
    setText("");
    setIsWrite(true);
  };

  const sendText = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    resetTranscript();
    if (text.trim().length < 5 || isWrite) return;
    sendMessageWithText(text.trim());
  };

  const handleChipSend = (prompt: string) => {
    if (prompt === "blank") {
      setChat([]);
      setText("");
      return;
    }
    if (prompt === "relatorio") {
      sendMessageWithText("Gere um relatório completo sobre o candidato.");
      return;
    }
    sendMessageWithText(prompt);
  };

  const microphoneFunc = () => {
    if (listening) {
      SpeechRecognition.stopListening();
    } else {
      SpeechRecognition.startListening();
    }
  };

  if (!browserSupportsSpeechRecognition) {
    return <span>Browser doesn't support speech recognition.</span>;
  }

  const onChangeFunc = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setText(e.target.value);
    e.target.style.height = "auto";
    e.target.style.height = `${e.target.scrollHeight}px`;
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter" && e.altKey) {
      e.preventDefault();
      const target = e.target as HTMLInputElement;
      setText(target.value + "\n");
    } else if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      console.log("Enter pressed, triggering sendText");
      sendText(e as unknown as React.FormEvent<HTMLFormElement>);
    }
  };

  function parseSelectionCandidatesFromMessage(
    text: string,
  ): { id: number; pessoal_nome?: string; [key: string]: any }[] | null {
    if (!text || typeof text !== "string") return null;
    const marker = "Dados dos candidatos:";
    const i = text.indexOf(marker);
    if (i < 0) return null;
    const after = text.slice(i + marker.length).trim();
    const start = after.indexOf("[");
    if (start < 0) return null;
    let depth = 0;
    let end = -1;
    for (let j = start; j < after.length; j++) {
      if (after[j] === "[") depth++;
      else if (after[j] === "]") {
        depth--;
        if (depth === 0) {
          end = j;
          break;
        }
      }
    }
    if (end < 0) return null;
    try {
      const arr = JSON.parse(after.slice(start, end + 1));
      if (!Array.isArray(arr) || arr.length === 0 || arr[0].id == null)
        return null;
      return arr;
    } catch (_) {
      return null;
    }
  }

  function getSelectionMessageIntro(text: string): string {
    const marker = "Dados dos candidatos:";
    const i = text.indexOf(marker);
    if (i < 0) return text;
    return text.slice(0, i).trim();
  }

  function openCVFromSelection(
    list: { id: number; pessoal_nome?: string; [key: string]: any }[],
    index: number,
  ) {
    const wData = list.map((c) => ({
      id: c.id,
      pessoal_nome: c.pessoal_nome ?? "",
      autohis_codigo: c.autohis_codigo ?? 0,
      idade: c.idade,
      pessoal_bairro: c.pessoal_bairro,
      pessoal_cidade: c.pessoal_cidade,
      pessoal_uf: c.pessoal_uf,
      nomecargo: c.nomecargo ?? "",
      autohis_dtincludo: c.autohis_dtincludo,
    }));
    setSelectionCandidatesList(wData);
    setModalCVIndex(index);
    setModalCVid(list[index].id);
    setModalCVAutoHCode(list[index].autohis_codigo ?? 0);
    setModalCVOpen(true);
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="user-dialog-title"
      maxWidth="sm"
      scroll="paper"
      className="modalAgnesAI "
      fullScreen
    >
      <DialogContent
        dividers={scroll === "paper"}
        style={{ height: "calc(100vh)", padding: 0 }}
        sx={{ p: 0, pl: 2 }}
      >
        <div
          style={{ height: "calc(-2px + 100vh)" }}
          className="flex flex-row gap-0 overflow-hidden w-full pl-2"
        >
          <div
            className={`flex-1 flex flex-col justify-center perspective overflow-hidden min-w-0  pb-2`}
          >
            <div
              className={`relative w-full flex flex-col  justify-between rounded-3xl 
          ${
            animationLoading ? "my-rotate-y-270" : "my-rotate-y-360"
          } preserve-3d backface-hidden h-full`}
            >
              <div
                id="scroll-id"
                ref={buttonRef}
                onScroll={handleChatBoxScroll}
                className="h-full px-3 py-2 md:px-6 md:py-4 gap-4 pr-2 overflow-y-auto overflow-x-hidden flex flex-col relative"
              >
                {currentSessionId != null && hasMoreMessages && (
                  <>
                    <div ref={messagesSentinelRef} className="min-h-2 h-2" />
                    {loadingMoreMessages && (
                      <div className="text-slate-500 text-xs py-2 text-center">
                        Carregando mais...
                      </div>
                    )}
                  </>
                )}
                {chat &&
                  chat.map((item: any, index: any) => {
                    const isLastAssistant =
                      index === chat.length - 1 && item.user === "assistant";
                    const showBubble =
                      item.text !== "" || (isLastAssistant && loading);
                    if (!showBubble) return null;
                    return (
                      <div
                        key={item.id ?? index}
                        className={`flex items-end ${
                          item.user === "user" ? "ml-auto" : "mr-auto"
                        } gap-2 text-slate-800`}
                      >
                        {item.user != "user" && (
                          <Avatar
                            sx={{
                              border: `1px solid ${theme.palette.primary.light}`,
                            }}
                            src="https://main.d1xvbis48sm8yx.amplifyapp.com/_next/static/media/ruti.5e914a94.png"
                          ></Avatar>
                        )}
                        <div
                          className={`mr-auto rounded-xl pt-2 pb-1 px-3 lg:max-w-xl max-w-sm md:max-w-md sm:max-w-md
                      ${
                        item.user === "user"
                          ? "text-white bg-slate-800 ml-[36px]"
                          : "text-slate-800 bg-white mr-[36px]"
                      } flex flex-col shadow-md shadow-slate-500`}
                        >
                          {isLastAssistant && loading && !item.text ? (
                            <span className="break-words text-xs sm:text-sm flex flex-col gap-1.5 py-1">
                              <div className="loader-dots block relative w-16 h-3">
                                <CircularProgress size={16} color="primary" />
                              </div>
                              <span className="text-slate-500 text-xs">
                                {agentStatusMessage || "Pensando..."}
                              </span>
                            </span>
                          ) : (
                            (() => {
                              const isLastAssistantMessage =
                                item.user === "assistant" &&
                                index === chat.length - 1;
                              const fromSocket =
                                isLastAssistantMessage &&
                                lastSelectionCandidates &&
                                lastSelectionCandidates.length > 0;
                              const selectionList = fromSocket
                                ? lastSelectionCandidates
                                : item.user === "assistant"
                                  ? parseSelectionCandidatesFromMessage(
                                      item.text || "",
                                    )
                                  : null;
                              const hasList =
                                selectionList &&
                                Array.isArray(selectionList) &&
                                selectionList.length > 0;
                              const intro =
                                hasList && !fromSocket
                                  ? getSelectionMessageIntro(item.text || "")
                                  : null;
                              return (
                                <span className="flex flex-col gap-2">
                                  {hasList && selectionList ? (
                                    <>
                                      {fromSocket ? (
                                        <ReactMarkdown className="agnes-ai-markdown break-words">
                                          {item.text && item.text}
                                        </ReactMarkdown>
                                      ) : (
                                        intro != null &&
                                        intro !== "" && (
                                          <ReactMarkdown className="agnes-ai-markdown break-words">
                                            {intro}
                                          </ReactMarkdown>
                                        )
                                      )}
                                      <div className="mt-2 space-y-1.5 border-t border-slate-200 pt-2">
                                        {selectionList.map(
                                          (
                                            c: {
                                              id: number;
                                              pessoal_nome?: string;
                                              pessoal_salario?: number;
                                              idade?: number;
                                              pessoal_cidade?: string;
                                              [key: string]: any;
                                            },
                                            idx: number,
                                          ) => (
                                            <div
                                              key={c.id ?? idx}
                                              className="flex items-center justify-between gap-2 py-1.5 px-2 rounded-lg bg-slate-50 hover:bg-slate-100"
                                            >
                                              <span className="text-sm truncate flex-1 min-w-0">
                                                <span className="text-slate-500 text-xs font-medium">
                                                  ID {c.id}
                                                </span>{" "}
                                                {c.pessoal_nome}
                                                {(c.pessoal_salario != null ||
                                                  c.idade != null ||
                                                  c.pessoal_cidade) && (
                                                  <span className="text-slate-500 text-xs block truncate">
                                                    {[
                                                      c.pessoal_salario !=
                                                        null &&
                                                        `R$ ${Number(c.pessoal_salario).toLocaleString("pt-BR")}`,
                                                      c.idade != null &&
                                                        `${c.idade} anos`,
                                                      c.pessoal_cidade,
                                                    ]
                                                      .filter(Boolean)
                                                      .join(" · ")}
                                                  </span>
                                                )}
                                              </span>
                                              <Button
                                                size="small"
                                                variant="outlined"
                                                className="shrink-0"
                                                onClick={() =>
                                                  openCVFromSelection(
                                                    selectionList,
                                                    idx,
                                                  )
                                                }
                                              >
                                                Ver CV
                                              </Button>
                                            </div>
                                          ),
                                        )}
                                      </div>
                                    </>
                                  ) : (
                                    <ReactMarkdown className="agnes-ai-markdown break-words">
                                      {item.text && item.text}
                                    </ReactMarkdown>
                                  )}
                                </span>
                              );
                            })()
                          )}
                          {isLastAssistant && loading && item.text ? (
                            <span className="text-slate-400 text-xs mt-1 flex items-center gap-1">
                              <span className="inline-block w-1.5 h-3 bg-slate-400 animate-pulse" />
                              digitando...
                            </span>
                          ) : null}
                          {item.text !== "" || !isLastAssistant ? (
                            <span
                              className={`text-[8px] sm:text-[10px] ml-auto -mb-[3px] mt-1 ${
                                item.user === "user"
                                  ? "text-white"
                                  : "text-slate-800"
                              } opacity-40`}
                            >
                              {item.time}
                            </span>
                          ) : null}
                        </div>
                      </div>
                    );
                  })}
                <div ref={messagesEndRef} />
              </div>
              <div className="flex flex-wrap gap-2 px-1 pb-2">
                {isDashboard && (
                  <>
                    <Chip
                      size="small"
                      label="Resumo do dia"
                      onClick={() =>
                        handleChipSend(
                          "Me dê um resumo do dia: seleções, entrevistas e chamados.",
                        )
                      }
                      disabled={isWrite}
                      variant="outlined"
                      className="cursor-pointer"
                    />
                    <Chip
                      size="small"
                      label="Seleções da semana"
                      onClick={() =>
                        handleChipSend(
                          "Quantas seleções a equipe fez esta semana?",
                        )
                      }
                      disabled={isWrite}
                      variant="outlined"
                      className="cursor-pointer"
                    />
                    <Chip
                      size="small"
                      label="Quem foi selecionado hoje?"
                      onClick={() =>
                        handleChipSend("Quem foi selecionado hoje?")
                      }
                      disabled={isWrite}
                      variant="outlined"
                      className="cursor-pointer"
                    />
                    <Chip
                      size="small"
                      label="Entrevistas hoje"
                      onClick={() =>
                        handleChipSend("Quem tem entrevista hoje?")
                      }
                      disabled={isWrite}
                      variant="outlined"
                      className="cursor-pointer"
                    />
                  </>
                )}
                {isCandidate && (
                  <>
                    {canInfo && (
                      <Chip
                        size="small"
                        label="Gerar relatório sobre o candidato"
                        onClick={() => handleChipSend("relatorio")}
                        disabled={isWrite}
                        variant="outlined"
                        className="cursor-pointer"
                      />
                    )}
                    <Chip
                      size="small"
                      label="Buscar candidato"
                      onClick={() =>
                        handleChipSend("Busque candidatos por nome ou perfil.")
                      }
                      disabled={isWrite}
                      variant="outlined"
                      className="cursor-pointer"
                    />
                  </>
                )}
                {isVacancy && (
                  <>
                    <Chip
                      size="small"
                      label="Listar vagas abertas"
                      onClick={() =>
                        handleChipSend("Quais são as vagas abertas no sistema?")
                      }
                      disabled={isWrite}
                      variant="outlined"
                      className="cursor-pointer"
                    />
                    <Chip
                      size="small"
                      label="Detalhes de uma vaga"
                      onClick={() =>
                        handleChipSend(
                          "Me fale sobre uma vaga (cargo, cliente ou código).",
                        )
                      }
                      disabled={isWrite}
                      variant="outlined"
                      className="cursor-pointer"
                    />
                    <Chip
                      size="small"
                      label="Executar seleção"
                      onClick={() =>
                        handleChipSend(
                          "Execute a seleção de uma vaga (informe o código da vaga).",
                        )
                      }
                      disabled={isWrite}
                      variant="outlined"
                      className="cursor-pointer"
                    />
                  </>
                )}
                {isClients && (
                  <>
                    <Chip
                      size="small"
                      label="Aniversariantes do mês"
                      onClick={() =>
                        handleChipSend("Quem faz aniversário este mês?")
                      }
                      disabled={isWrite}
                      variant="outlined"
                      className="cursor-pointer"
                    />
                    <Chip
                      size="small"
                      label="O que tenho no calendário hoje?"
                      onClick={() =>
                        handleChipSend("O que tenho no calendário hoje?")
                      }
                      disabled={isWrite}
                      variant="outlined"
                      className="cursor-pointer"
                    />
                  </>
                )}

                <Chip
                  size="small"
                  label="Dúvidas sobre RH"
                  onClick={() =>
                    handleChipSend(
                      "Tenho dúvidas sobre processos de RH, pode me ajudar?",
                    )
                  }
                  disabled={isWrite}
                  variant="outlined"
                  className="cursor-pointer"
                />
              </div>
              <form
                onSubmit={sendText}
                className=" flex justify-between items-center pr-2 "
              >
                {/* <Input.TextArea
                autoSize={{ minRows: 2, maxRows: 6 }}
                onKeyDown={handleKeyDown}
                disabled={isWrite}
                onChange={(e) => onChangeFunc(e)}
                value={text}
                placeholder="Haydi sohbet edelim.."
                className="rounded-xl mr-4 md:ml-4 ml-1 overflow-hidden"
              /> */}
                <Grid container>
                  <Grid item xs={12} md={12} lg={12}>
                    <TextField
                      margin="normal"
                      size="small"
                      autoComplete="off"
                      multiline
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      id="contato"
                      onKeyDown={handleKeyDown}
                      InputProps={{
                        endAdornment: (
                          <div className="flex gap-2 md:gap-3 md:px-2">
                            <Tooltip disableInteractive title={`Resetar Chat`}>
                              <button
                                type="reset"
                                disabled={isWrite}
                                onClick={() => setChat([])}
                                className={`w-10 h-10 ${
                                  !listening && "hover:scale-105"
                                } ${
                                  listening && "animate-pulse scale-110"
                                } bg-slate-800 cursor-pointer transition-transform rounded-full flex justify-center items-center`}
                              >
                                <RestartAlt
                                  className={`w-5 h-5 text-neutral-200  `}
                                />
                              </button>
                            </Tooltip>
                            <Tooltip disableInteractive title={`Ditar`}>
                              <button
                                type="reset"
                                disabled={isWrite}
                                onClick={() => microphoneFunc()}
                                className={`w-10 h-10 ${
                                  !listening && "hover:scale-105"
                                } ${
                                  listening && "animate-pulse scale-110"
                                } bg-slate-800 cursor-pointer transition-transform rounded-full flex justify-center items-center`}
                              >
                                <KeyboardVoice
                                  className={`w-5 h-5 text-neutral-200  `}
                                />
                              </button>
                            </Tooltip>
                            <Tooltip disableInteractive title={`Enviar`}>
                              <button
                                disabled={isWrite}
                                type="submit"
                                onClick={() =>
                                  console.log(
                                    "Send button clicked, isWrite:",
                                    isWrite,
                                    "text:",
                                    text,
                                  )
                                }
                                className="w-10 h-10 bg-slate-800 hover:scale-105 cursor-pointer group transition-transform rounded-full flex justify-center items-center"
                              >
                                <Send className="w-4 h-4 text-neutral-200 " />
                              </button>
                            </Tooltip>
                          </div>
                        ),
                      }}
                      placeholder="Escreva aqui..."
                      name="contato"
                      value={text}
                      onChange={(e) => onChangeFunc(e)}
                    />
                  </Grid>
                </Grid>
              </form>
              <div
                onClick={() => scrollToBottom()}
                className={`${!showScrollToButton && "hidden"} ${
                  !animationLoading && ""
                } absolute bottom-20 right-8 z-50 bg-neutral-200 transition-transform 
            cursor-pointer animate-bounce flex justify-center items-center rounded-full`}
              >
                <ArrowDownward className="text-slate-800 w-12 h-12" />
              </div>
            </div>
          </div>

          <aside className="w-64 shrink-0 border-l border-slate-200 bg-slate-50 flex flex-col overflow-hidden">
            <button
              type="button"
              onClick={createNewSession}
              className="m-3 flex items-center justify-center gap-2 py-2 px-3 rounded-xl bg-slate-800 text-white hover:bg-slate-700 transition-colors text-sm font-medium"
            >
              <Add className="w-5 h-5" />
              Nova conversa
            </button>
            <div
              ref={sessionsListRef}
              className="flex-1 overflow-y-auto px-2 pb-3"
            >
              {loadingSessions ? (
                <div className="text-slate-500 text-sm py-4 text-center">
                  Carregando...
                </div>
              ) : sessions.length === 0 ? (
                <div className="text-slate-500 text-sm py-4 text-center">
                  Nenhuma conversa
                </div>
              ) : (
                <>
                  {sessions.map((s) => (
                    <div key={s.id} className="group relative rounded-lg mb-1">
                      <button
                        type="button"
                        onClick={() => loadSessionMessages(s.id)}
                        className={`w-full text-left py-2.5 px-3 pr-10 rounded-lg text-sm transition-colors ${
                          currentSessionId === s.id
                            ? "bg-slate-800 text-white"
                            : "text-slate-700 hover:bg-slate-200"
                        }`}
                      >
                        <span className="block truncate">{s.title}</span>
                        <span
                          className={`block text-xs mt-0.5 ${currentSessionId === s.id ? "text-slate-300" : "text-slate-400"}`}
                        >
                          {s.updated_at
                            ? new Date(s.updated_at).toLocaleDateString(
                                "pt-BR",
                                {
                                  day: "2-digit",
                                  month: "2-digit",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                },
                              )
                            : ""}
                        </span>
                      </button>
                      <Tooltip title="Excluir conversa">
                        <IconButton
                          size="small"
                          onClick={(e) => confirmDeleteSession(e, s.id)}
                          onMouseDown={(e) => e.stopPropagation()}
                          className="!absolute !right-1 !top-1/2 !-translate-y-1/2 opacity-0 group-hover:opacity-100 focus:opacity-100 transition-opacity"
                          sx={{
                            color:
                              currentSessionId === s.id
                                ? "rgba(255,255,255,0.8)"
                                : "text.secondary",
                            "&:hover": {
                              backgroundColor:
                                currentSessionId === s.id
                                  ? "rgba(255,255,255,0.1)"
                                  : "action.hover",
                            },
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </div>
                  ))}
                  <div ref={sessionsSentinelRef} className="h-2 min-h-2" />
                  {loadingMoreSessions && (
                    <div className="text-slate-500 text-xs py-2 text-center">
                      Carregando mais...
                    </div>
                  )}
                </>
              )}
            </div>
          </aside>
        </div>
      </DialogContent>
      <Dialog
        open={sessionToDelete != null}
        onClose={() => !deletingSession && setSessionToDelete(null)}
      >
        <DialogTitle>Excluir conversa?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Esta conversa e todas as mensagens serão excluídas. Esta ação não
            pode ser desfeita.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setSessionToDelete(null)}
            disabled={deletingSession}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleDeleteSession}
            color="error"
            variant="contained"
            disabled={deletingSession}
          >
            {deletingSession ? "Excluindo..." : "Excluir"}
          </Button>
        </DialogActions>
      </Dialog>
      <ModalCVSelection
        open={modalCVOpen}
        onClose={() => setModalCVOpen(false)}
        onAdd={() => {}}
        onUpdate={() => {}}
        setCanId={(id: number) => setModalCVid(id)}
        setModalCVIndex={setModalCVIndex}
        setModalCVAutoHCode={setModalCVAutoHCode}
        title="CV do candidato"
        wData={selectionCandidatesList}
        processing={false}
        modalIndex={modalCVIndex}
        canId={modalCVid}
        modalCVAutoHCode={modalCVAutoHCode}
      />
    </Dialog>
  );
};

export default ModalAgnesAI;
